import * as React from 'react';
import { TableRow, TableColumn } from './TableWidget';
import * as _ from 'lodash';
import { MouseEvent } from 'react';
import { TableRowWidget } from './TableRowWidget';

export interface TableRowsWidgetProps<T extends TableRow> {
  rows: T[];
  cols: TableColumn<T>[];
  onContextMenu?: (event: MouseEvent, row: T) => any;
  onRowSelected?: (event: MouseEvent, row: T) => any;
}

export class TableRowsWidget<T extends TableRow = TableRow> extends React.Component<TableRowsWidgetProps<T>> {
  render() {
    return (
      <>
        {_.map(this.props.rows, (row, index) => {
          return (
            <TableRowWidget<T>
              key={`row-${index}`}
              {...this.props}
              row={row}
              onSelect={(event: MouseEvent, row: T) => {
                this.props.onRowSelected?.(event, row);
              }}
            />
          );
        })}
      </>
    );
  }
}
